import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function Coverage() {
  const items = ['Adultos que empiezan de cero', 'Cualquier edad', 'Principiantes absolutos', 'Sin conocimientos previos', 'Sin partituras ni teoría', 'Sin profesor particular', 'Aprendizaje a tu ritmo', 'Coordinación de ambas manos', 'Lectura básica de notas', 'Repertorio moderno y clásico', 'Práctica desde casa', 'Método 100% visual'];
  return <section className="py-16 md:py-20 bg-navy relative overflow-hidden" data-id="element-28">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-gold/8 rounded-full blur-3xl pointer-events-none" data-id="element-29"></div>

      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-30">
        <FadeIn data-id="element-31">
          <h2 className="text-2xl md:text-3xl font-black text-center text-beige mb-3 max-w-xl mx-auto" data-id="element-32">
            Funciona desde hoy{' '}
            <span className="text-gold" data-id="element-33">
              aunque nunca hayas tocado un piano
            </span>
            .
          </h2>
          <p className="text-center text-gold text-xs md:text-sm font-bold uppercase tracking-[0.25em] mb-8" data-id="element-34">
            Qué incluye el método:
          </p>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-35">
          <div className="flex flex-wrap justify-center gap-2 max-w-xl mx-auto" data-id="element-36">
            {items.map((item, index) => <div key={index} className="inline-flex items-center gap-1.5 bg-navy-lighter border border-gold/25 hover:border-gold/50 transition-colors text-beige/90 text-sm font-medium px-3.5 py-2 rounded-full whitespace-nowrap" data-id="element-37">
                <CheckCircle2 className="w-3.5 h-3.5 text-gold flex-shrink-0" data-id="element-38" />
                <span data-id="element-39">{item}</span>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}